import { render, staticRenderFns } from "./NetworkIndicator.vue?vue&type=template&id=405be4bc&"
import script from "./NetworkIndicator.vue?vue&type=script&lang=ts&"
export * from "./NetworkIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports